import React, {createRef, useState, useContext} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import { Icon, useTheme } from "@material-ui/core";
import MaterialTable from "@material-table/core";
import {defaultComponentsScroll, MaterialTableBody} from "../../../controls/Material-Table-Components";
import useDimensions from "../../../blocks/useDimensions";
import { FullWidthFilter } from "../../../controls/Material-Table-Components/MaterialTableFilters";
import SystemContext from "../../../SystemContext";
import {ColumnWidth } from "../../../blocks/ColumnHelper";
// import AirportsListValidator from "../validators/AirportsListValidator";

import { useAirports, useAddAirport, useUpdateAirport } from "../../../services/airports";

const AirportList = (_props) => {
  const {isAuthenticated} = useAuth0();
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const eventBus = SystemData.eventBus;
  // const validatorColumn = ValidatorColumn(AirportsListValidator, true);

  const props = {
    ..._props
  }
  const classes = props.classes;
  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  const tableRef = createRef({state: {lastEditingRow: false}});

  const handleAddAirport = useAddAirport();
  const handleUpdateAirport = useUpdateAirport();
  // const handleDeleteAirport = useDeleteAirport();

  const queryClient = useQueryClient();
  const extraKeys = [];

  const airports = useAirports({tableRef, queryClient, extraKeys});

  const handleRowClick = (event, rowData) => {
    if (rowData.tableData.id >= 0) {
      if (eventBus) {
        eventBus.trigger('AirportList.rowSelected', rowData);
      }
    }
  }

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { fontSize:13, padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      filterCellStyle: { padding: "8px 2px" },
      editable: state.canEdit?"always":"never",
    };

    return [
      /*
        Can use ...ColumnWidth(70) to generate a fixed width column
      */
      // {...validatorColumn, filtering: false},
      {
        ...baseColumn,
        ...ColumnWidth(60),
        title: "Code",
        field: "airportCode",
        filterComponent: FullWidthFilter,
      },
      {
        ...baseColumn,
        ...ColumnWidth(15),
      },
      {
        ...baseColumn,
        ...ColumnWidth(305,2,undefined,{paddingLeft: 10},undefined,undefined,false),
        title: "Airport Name",
        field: "airportName",
        filterComponent: FullWidthFilter,
      },
    ];
  };
  const [tableContainerRef, {height: tableHeight}] = useDimensions({});
  const theader = tableContainerRef.current?.querySelector('thead');
  const thead = theader ? theader.clientHeight : 36;
  const bodyHeight = tableHeight - thead - 6;
  console.log(thead, bodyHeight)

  return (isAuthenticated &&
      <div style={{width: "100%", marginLeft: 20, marginRight: 20}}>
        <div style={{background: "#ffffff", width: "calc(100% - 24px)", paddingTop: 16, paddingLeft: 20, paddingRight: 4}}>
          <div ref={tableContainerRef} className={state.canEdit?classes.airportListEdit:classes.airportList} style={{width: "100%", minWidth: "100%", height: `calc(100vh - ${props.height + 18}px)`}}>
            <MaterialTable
              icons={{ Filter: React.forwardRef((props, ref) => <Icon className="filterIcon">filter_list</Icon> )}}
              tableRef={tableRef}
              style={{
                border: "none",
                boxShadow: "none",
                borderRadius: 0,
              }}
              onRowClick={handleRowClick}
              options={{
                tableRef,
                highlightRowStyle: {backgroundColor: "#F69259"},
                actionsColumnIndex: -99,
                cellStyle: {
                  padding: "8px 2px",
                },
                headerStyle: {
                  backgroundColor: '#3f3f3f',
                  color: theme.palette.primary.main,
                  padding: 2,
                },
                draggable: false,
                toolbar: false,
                toolbarButtonAlignment: "right",
                pageSize: 10,
                detailPanelType: "single",
                padding: 'dense',
                paging: false,
                filtering: true,
                searchFieldAlignment: "left",
                addRowPosition: "first",
              }}
              components={{
                ...defaultComponentsScroll,
                Body: (props) => (
                  <MaterialTableBody
                    {...props}
                    rowHeight={46}
                    overscanRowCount={10}
                    addVirtualScrolling={true}
                    bodyHeight={bodyHeight>0?bodyHeight:500}
                    headerHeight={thead}
                    filterRowHeight={46}
                  />
                )
              }}
              title="Airport Management"
              columns={getColumns({canEdit: false})}
              data={airports.data}
              editable={{
                isEditable: () => {
                  return state.canEdit;
                },
                isDeletable: () => {
                  return state.canEdit;
                },
                onRowAdd: state.canEdit
                    ? (newData) => new Promise((resolve, reject) => {
                      handleAddAirport.mutate({record: newData, resolve, reject, extraKeys});
                    })
                    : undefined,
                onRowUpdate: (newData, oldData) =>
                    new Promise((resolve, reject) => {
                      handleUpdateAirport.mutate({record: newData, oldRecord: oldData, resolve, reject, extraKeys});
                    }),
                // onRowDelete: (oldData) =>
                //     new Promise((resolve, reject) => {
                //       handleDeleteAirport.mutate({oldRecord: oldData, resolve, reject, extraKeys});
                //     }),
              }}
            />
          </div>
        </div>
      </div>
  );

}

export default AirportList;
